import { render, staticRenderFns } from "./Recipients.vue?vue&type=template&id=0e76fefb&scoped=true&"
import script from "./Recipients.vue?vue&type=script&lang=js&"
export * from "./Recipients.vue?vue&type=script&lang=js&"
import style0 from "./Recipients.vue?vue&type=style&index=0&id=0e76fefb&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e76fefb",
  null
  
)

export default component.exports